<template>
  <div class="home" :class="{ active: type != 2 && type != 3, active2: type == 2, active3: type == 3 }">
    <!-- <img v-if="type == 3" src="../assets/bg_top.png" class="top-img" alt="top"> -->
    <div class="pdfCom">
      <vue-pdf :src="pdfSrc"></vue-pdf>
    </div>
    <!-- <img v-if="type == 3" src="../assets/bg_bot.png" class="bot-img" alt="bottom"> -->
  </div>
</template>
  
<script>
import pdf from "vue-pdf";

export default {
  name: "Home",
  components: {
    "vue-pdf": pdf,
  },
  data() {
    return {
      pdfSrc: "",
      type: "",
      userAdmin: "",
    };
  },
  watch: {},
  mounted() {
    this.userAdmin = "http://1.116.138.154" || this.getUserDomain();
    const { name, file, type } = this.$route.query;
    console.log("xxx", name, file, type);
    this.type = type;
    if (type == "2") {
      /*生成32位随机流水号*/
      /*默认去掉了容易混淆的字符oOLl,9gq,Vv,Uu,I1*/
      let $chars = "abcdefhijkmnprstwxyz2345678";
      let maxPos = $chars.length;
      let title = "";
      for (let i = 0; i < 32; i++) {
        title += $chars.charAt(Math.floor(Math.random() * maxPos));
      }

      document.title = title;
      this.pdfSrc = this.userAdmin + "/" + file + "/" + name + ".pdf";
    } else if (type == "3") {
      this.pdfSrc = this.userAdmin + "/" + file + "/" + name + ".pdf";
      document.title = "教育部学历证书电子注册备案表";
    } else {
      this.pdfSrc = this.userAdmin + "/" + file + "/" + name + ".pdf";
    }
    console.log("ccc", this.getUserDomain());
  },
  methods: {
    getUserDomain() {
      const url = window.location.href; // 获取当前页面的URL
      const domain = url.split("/")[2]; // 通常域名位于第二部分，例如 https://example.com/page
      return domain;
    },
  },
};
</script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.home {
  width: 100%;
  height: 100%;
  background-color: rgb(14, 14, 14);
  padding-top: 0;
  width: 100%;
  height: 100vh;
  position: relative;
}

.home.active {
  background: url("../assets/bg_01.png") no-repeat;
  background-size: contain;
  padding-top: 10px;
  height: calc(100vh - 10px);
  background-color: #3e3e3e;
}

.home.active2 {
  display: flex;
  justify-content: center;
  align-items: center;
}



.home.active2 {
  display: flex;
  justify-content: center;
  align-items: center;
}

.pdfCom {
  width: calc(100% - 30px);
  margin-top: 0;
  padding: 0 15px;
}
.home.active .pdfCom {
  margin-top: 33px;
  padding-top: 20px;
}

.home.active2 .pdfCom {
  width: 100%;
  padding: 0;
}

.home.active3 .pdfCom {
  width: 100%;
  padding: 0;
}

.home.active3 {
  display: flex;
  flex-direction: column;
}

.top-img {
  width: 100%;
  display: block;
}

.bot-img {
  width: 100%;
  display: block;
}

.home.active3 .pdfCom {
  flex: 1;
}
</style>
  